import React, { Component } from 'react';
import './App.scss';
import PageMenu from "./PageMenu";
import PageLogin from "./PageLogin";
import PageNoRole from "./PageNoRole";
import 'bootstrap/dist/css/bootstrap.css';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faPlus } from '@fortawesome/free-solid-svg-icons'

library.add(faPlus)

class App extends Component {
  static webUser = undefined;
  static session = undefined;

  constructor(){
    super();
    this.state = {
      pageID: undefined
    }
  }

  static getHighestRole(){
    if (App.webUser === undefined){ return "not_logged_in"; }
    if (App.webUser.Role === "wifi"){ return "wifi"; }
    if (App.webUser.Role === null){ return "no_role"; }
    return "no_role";
  }

  onLogin(){
    this.setState({
      pageID: "menu"
    });
  }

  render() {
    var me = this;
    return (
      <div className="container">
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark ">
          <div className="navbar-brand">KIG Radius</div>
          <button className="navbar-toggler" type="button"
          data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
          aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav mr-auto">
              {App.getHighestRole() === 'wifi' ? 
                <li className="nav-item active">
                {/*
                  <a className="nav-link" href="aa">Saját wifi-azonosítók</a>
                */}
                </li>
              :
                <div></div>
              }
            </ul>
          </div>
        </nav>

        <div className="pageHolder">
          {App.getHighestRole() === 'not_logged_in' ? <PageLogin onLogin={me.onLogin.bind(me)} /> : undefined}
          {App.getHighestRole() === 'no_role' ? <PageNoRole /> : undefined}
          {App.getHighestRole() === 'wifi' ?
            <>
              {me.state.pageID === 'menu' ? <PageMenu /> : undefined}
            </>
          : 
            undefined
          }
        </div>
      </div>
    );
  }
}

export default App;